<template>
    <div class="ccpay-ordetail">
        <div class="ccpay-order-header">
             <span @click="back">返回</span>
             <span>订单详情</span>
             <span></span>
        </div>
        <div class="ccpay-order-connect">
            <ul style="padding: 1rem;" v-show="data">
              <li>
                    <p>
                        <span >
                            <b>订单编号 </b>
                        </span>
                        <span> ：{{data.order_no}}</span>
                         <span class="fl-r tag-read" 
                         
                        :data-clipboard-text="data.order_no" @click="copy">复制</span>
                     </p>
                </li>
                <li   >
                    <p>
                        <span >
                        <b>订单时间</b> ：{{data.created_time}}
                        </span>
                        <!-- <span></span> -->
                        <!-- <span class="fl-r tag-read" 
                        :data-clipboard-text="data.name" @click="copy">复制</span> -->
                    </p>
                </li>
                  <li   >
                    <p>
                        <span >
                        <b>订单倒计时</b> ：<span  >{{this.restStr}}</span>
                        </span>
                        <!-- <span></span> -->
                        <!-- <span class="fl-r tag-read" 
                        :data-clipboard-text="data.name" @click="copy">复制</span> -->
                    </p>
                </li>
                
                <li class="bg-f-w">
                    <p>
                        <span >
                        <b>姓名</b> ：<a  :style="{'color':data.side=='BUY'?'#54BCA5':'#CA595B'}" >{{data.name}}</a>
                        </span>
                         <span class="fl-r tag-read" 
                       
                        :data-clipboard-text="data.name" @click="copy">复制</span> 
                    </p>
                </li>
                
                
              
              
                 <li class="bg-f-w" >
                     <p>
                         <span >
                        <b>数量 </b>：<a :style="{'color':data.side=='BUY'?'#54BCA5':'#CA595B'}">{{parseFloat(Number(data.amount))}} <!--  {{data.currency}} --></a>
                        <span style="float:right">  <b >单价 </b>：<a :style="{'color':data.side=='BUY'?'#54BCA5':'#CA595B'}">{{toFixed(data.coin_price,2)}} </a></span>
                        </span>
                         <!-- <span class="fl-r tag-read" 
                        :data-clipboard-text="data.amount" @click="copy">复制</span> -->
                      </p>
                </li>
               
                 <li class="bg-f-w">
                    <p>
                         <span class="detail-spo" style="margin-bottom:0rem">
                            <span> 
                                <b>金额 </b>：<a :style="{'color':data.side=='BUY'?'#54BCA5':'#CA595B'}">{{data.legal_amount.toString().match(/^\d+(?:\.\d{0,4})?/)[0]}} <!--{{data.legal_currency}} --></a>
                                &nbsp;&nbsp;<span class="fl-r tag-read"
                                :data-clipboard-text="data.legal_amount.toString().match(/^\d+(?:\.\d{0,4})?/)[0]" @click="copy">复制</span> 
                            </span> 
                          <span style="float:right">  <b >类型 </b>：<a :style="{'color':data.side=='BUY'?'#54BCA5':'#CA595B'}">{{data.side=='BUY'?'买单':'卖单'}} </a></span>
                       </span>
                         <!-- <span class="fl-r tag-read" 
                        :data-clipboard-text="data.legal_currency" @click="copy">复制</span> -->
                     </p>
                </li>
                <li v-show="paytypeflag" style="padding-top:1rem;padding-bottom:1rem">
                   <p>
                      <span style="color:#26a2ff" @click="paytype=!paytype" > 切换支付方式</span>
                   </p>
               </li>
                <li  v-show="data.bank_account_name&&paytype">
                    <p>
                       
                            <span>   <b>银行卡姓名 </b>：{{data.bank_account_name}}</span> 
                          
                         <span class="fl-r tag-read"  
                        :data-clipboard-text="data.bank_account_name" @click="copy">复制</span> 
                    </p>
                </li>
                <li v-show="data.bank_name&&paytype">
                    <p>
                    <span ><b>银行名称 </b>：{{data.bank_name}}</span>
                    <!-- <span> </span> -->
                    <!--   <span class="fl-r tag-read" 
                        :data-clipboard-text="data.bank_name" @click="copy">复制</span>  -->
                    </p>
                </li>
                <li v-show="data.bank_branch_name&&paytype">
                    <p>
                    <span class="detail-spo"><b>银行地址 </b></span>
                    <span>{{data.bank_branch_name}}</span>
                     <span class="fl-r tag-read" 
                        :data-clipboard-text="data.bank_branch_name" @click="copy">复制</span>
                    </p>
                </li>
                <li  v-show="data.bank_account_no&&paytype">
                    <p>
                    <span class="detail-spo"><b>银行卡号 </b></span>
                    <span>{{data.bank_account_no}}</span>
                     <span class="fl-r tag-read" 
                            
                        :data-clipboard-text="data.bank_account_no" @click="copy">复制</span>
                    </p>
                </li>
                <li  v-show="data.alipay_account_name&&!paytype">
                    <p>
                        <span >
                        <b>支付宝姓名</b>：{{data.alipay_account_name}}
                        </span>
                        <span></span>
                        <span class="fl-r tag-read" 
                        :data-clipboard-text="data.alipay_account_name" @click="copy">复制</span> 
                     </p>
                </li>
                <li class="bg-f-w" v-show="data.alipay_account_no&&!paytype">
                      <p>
                    <span class="detail-spo"><b>支付宝账号 </b></span>
                    <span>{{data.alipay_account_no}}</span>
                     <span class="fl-r tag-read" 
                     
                        :data-clipboard-text="data.alipay_account_no" @click="copy">复制</span>
                    </p>
                   
                </li>
                 <!-- <div v-show="data.alipay_account_name&&!this.data.bank_account_name">
                       <mt-button
                         class="mt-40" size="large" type="primary" 
                         @click="emit('user',data.order_no)">放行</mt-button>
                 </div> -->
                 <!-- 客户放行 -->
                 <mt-button   
                   class="bg-f-b mt-40"
                 v-show="data.side=='SELL'&&data.status=='CREATED'"
                  size="large" type="primary" 
                        @click="emit('user',data.order_no)">我已付款</mt-button>
                <mt-button   
                  class="bg-f-b mt-40"
                 v-show="data.side=='SELL'&&data.status=='CREATED'"
                   size="large" type="primary" 
                        @click="changeorder(data.order_no)">转单</mt-button>
                   <!-- 交易员放行 -->
                 <mt-button
                 class="bg-f-b mt-40"
                        v-show="data.side=='BUY'&&data.status=='PAID'||data.side=='BUY'&&data.status=='CREATED'"
                        size="large" type="primary" 
                        @click="Unknownpayment('pople',data.order_no)">放行</mt-button>
            </ul>
        </div>
    </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import {toFixed,Formatnumbers} from '../../public/index.js'
import Clipboard from 'clipboard';
import moment from  "moment"
export default {
    data(){
        return {
            data:null,
            paytype:true,
            paytypeflag:false,
            restTimer:null,//订单倒计时
            restStr:''
        }
    },
    mounted() {
        let id = this.$route.query.orderid
        this.$axios(`/v1/traders/order/detail?order_no=${id}`).then(res=>{
            if(res.code==0){
                this.data = res.data
                this.restTime(res.data.plan_end_time)
                if(res.data.bank_name){
                      this.paytype = true
                }else{
                     this.paytype = false
                }
                if(res.data.bank_name&&res.data.alipay_account_name){
                    this.paytypeflag = true
                }else{
                    this.paytypeflag = false
                }
                //    console.log(res.data)
            }
          
        })
    },
    destroyed(){
         clearInterval(this.restTimer)
    },
    methods:{
        Formatnumbers,
        toFixed,
        moment,
        back(){
            this.$router.go(-1)
        },
      
        restTime(time){
            
            this.restTimer = setInterval(() => {
                
                 var settime = moment(time).valueOf()
                 var nowtime = moment().valueOf()
                
                 var restsec = settime - nowtime
                if(restsec<0){
                     return this.restStr = '已超时'
                 }
                 var minu = parseInt((restsec / (60 * 1000)) % 60);
                 var sec = parseInt((restsec / 1000) % 60);
                 this.restStr = minu + ":" + this.zero(sec);
                 
             },1000)
            
        },
        zero(sec) {
            if (sec < 10) {
                return "0" + sec;
            } else {
                return sec;
            }
        },
        //二次提示付款
        Unknownpayment(type,id){
            // data.status=='PAID'
            this.$MessageBox.confirm('',{
                title:'提示',
                message:'请确认该订单已收款！',
                confirmButtonText:'确定',
                cancelButtonText:'取消'
            }).then(action => {
                 this.emit(type,id)
            //    console.log('确定'); 
            }).catch(error =>{
                
            //   console.log('取消'); 
            })
        },
        //选择放行方式  一个或者两个    
        emit(type,id){
            
            if(this.data.alipay_account_name&&this.data.bank_account_name){
                this.bothsides(type,id)
                return
            }
            if(this.data.alipay_account_name){//支付宝
                this.pay(type,id)
                return
            }

            //  console.log('?????')
            if(this.data.bank_name){//银行
                this.Bank(type,id)
               
                return
            }
        },
        //支付宝或银行卡
        bothsides(type,id){
            let code,tit;
            if(type=='user'){
                code= 'paid'
                tit = `请选择您的放行方式 `
            }else{
                code ='recived'
                tit = `请选择您的放行方式 `
            }
            // console.log(code,'codecode')
            this.$MessageBox.confirm('',{
                title:'提示',
                message:tit,
                confirmButtonText:'银行卡',
                cancelButtonText:'支付宝'
            }).then(action => {
               this.Release('BANKPAY',code,id)
            //    console.log('银行卡'); 
            }).catch(error =>{
                this.Release('ALIPAY',code,id)
            //   console.log('支付宝'); 
            })
        },
       
        //支付宝
        pay(type,id){
            let code
            if(type=='user'){
                code= 'paid'
            }else{
                code ='recived'
            }
            this.$MessageBox.confirm('',{
                title:'提示',
                message:'当前放行账号为支付宝账户',
                confirmButtonText:'请确定放行',
                cancelButtonText:'取消',
                showCancelButton:false
            }).then(action => {
                 this.Release('ALIPAY',code,id)
            }).catch(error =>{
          
            })
        },
        //银行卡
        Bank(type,id){
            
             let code;
            if(type=='user'){
                code= 'paid'
            }else{
                code ='recived'
            }
            this.$MessageBox.confirm('',{
                title:'提示',
                message:'当前放行账号为银行卡账户',
                confirmButtonText:'请确定放行',
                cancelButtonText:'取消',
                showCancelButton:false
            }).then(action => {
                 this.Release('BANKPAY',code,id)
            }).catch(error =>{
          
            })
        },
        //放行
         Release(type,code,id){
          
             Indicator.open();
            this.$axios.post(`/v1/traders/order/${code}`,{
                "account_type":type,
                "order_no": id
            }).then(res=>{
                Indicator.close();
                if(res.code==0){
                    this.$Toast('标记付款成功')
                    this.back()
                }else{
                    this.$Toast(res.msg)
                    this.back()
                }
            })
        },
        changeorder(id){

            this.$MessageBox.confirm('',{
                title:'提示',
                message:'您是否确定转单',
                confirmButtonText:'确认',
                cancelButtonText:'取消',
                showCancelButton:true
            }).then(action => {
                Indicator.open();
                this.$axios.post('/v1/traders/order/transfer',{
                 "order_no":id,
                }).then(res=>{
                     Indicator.close();
                    if(res.code==0){
                        this.$Toast('转单成功')
                        this.back()
                    }else{
                        this.$Toast(res.msg)
                        this.back()
                    }
                })
            }).catch(error =>{
          
            })


            
        },
        copy(){
            var clipboard = new Clipboard('.tag-read')
                clipboard.on('success', e => {
        //           console.log('复制成功')
                    this.$Toast('复制成功')
                  // 释放内存
                  clipboard.destroy()
                })
                clipboard.on('error', e => {
                  // 不支持复制
               this.$Toast('该浏览器不支持自动复制')
        //           console.log('该浏览器不支持自动复制')
                  // 释放内存
                  clipboard.destroy()
                })
        },
    }
}
</script>

<style lang="scss" scoped>
.ccpay-ordetail{
    b{
        font-weight:400;
    }
}
.card-css{
}
.gr76{
   color: rgb(76, 175, 80)
}
.gred{
   color: red;
}

.bg-f-w{
         -webkit-transform: translateZ(0px);
        transform: translateZ(0px);
        font-size: 14px;
        // -webkit-box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
       // box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
        // border-radius: 8px;
       // transition: transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s, -webkit-transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s;
}
.bg-f-b{
        padding: 1.5rem;
    line-height: 0rem;
    // background-color: dimgrey;
    
            -webkit-transform: translateZ(0px);
            transform: translateZ(0px);
            font-size: 14px;
            // -webkit-box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
            // box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
            // // border-radius: 8px;
            // transition: transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s, -webkit-transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s;

}
    .ccpay-ordetail{
        
        height:100%;
        background: white;
        // padding-top: 3rem;
        .ccpay-order-header{
             position: fixed;
            top: 0;
            z-index: 999;
            height: 3rem;
            line-height: 3rem;
            width: 100%;
            background: white;
            display: flex;
            justify-content: space-around;
        }
        .ccpay-order-connect{
            padding-top: 3rem;
            ul li{
                border-bottom: 1px solid #eee;
                display: flex;
                font-size: 16px;
                line-height: 1;
                min-height: inherit;
                overflow: hidden;
                padding: 0 10px;
                padding: 1rem;
                p{
                    width: 100%;
                }
                .fl-r{
                    float: right;
                    color: #26a2ff;
                }
                .detail-spo{
                    margin-bottom: 1rem;
                    min-width: 5.5rem;
                    display: inline-block;
                    display: flex;
                    justify-content: space-between;
                }
            }
        }
    } 
</style>



// WEBPACK FOOTER //
// src/components/order/orderdetail.vue